module.exports = __webpack_public_path__ + "static/2-c8c21b66c25575e9515dabd3055a2596.png";